import React from 'react';
import { C } from '../../styles/tokens';
import { CREDIT_RATES } from '../../constants/creditRates';

export default function CreditRatesCard() {
  return (
    <div style={{ background: C.w, border: `1px solid ${C.n200}`, borderRadius: 13, marginBottom: 26, overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: `1px solid ${C.n100}` }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.n900 }}>How credits are used</div>
        <div style={{ fontSize: 12, color: C.n500, marginTop: 1 }}>Credit cost per feature, deducted from your monthly allowance</div>
      </div>
      <div style={{ padding: '4px 20px' }}>
        {CREDIT_RATES.map((r, i) => (
          <div
            key={r.label}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '11px 0', borderBottom: i < CREDIT_RATES.length - 1 ? `1px solid ${C.n100}` : 'none',
            }}
          >
            <span style={{ fontSize: 13, color: C.n700, fontWeight: 500 }}>{r.label}</span>
            <span style={{ fontSize: 12.5, color: C.n500, textAlign: 'right' }}>
              <strong style={{ color: C.n900, fontWeight: 700 }}>{r.cost}</strong> {r.unit}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
